<template>
    <div class="header" :class="{'dark-style': darkStyleRoutes.includes($route.name)}">
     
    </div>
</template>
<script>
import Logo from '../Logo'
export default {
    components: {
        Logo
    },
    computed: {
        username() {
            return this.$store.state.username?this.$store.state.username:localStorage.getItem('username')
        }
    },
    data() {
        return {
            // 隐藏logo的route name
            logoHiddenRoutes: ['home'],
            // dark模式的route name
            darkStyleRoutes: ['home'],
            // 跳转至外部的route name
            alinkRoutes: ['about', 'github', 'endpoint','Visulization'],
            userid:localStorage.getItem('userid'),
            // username:localStorage.getItem('username'),
            tabBar: [
                {
                    value: 'home',
                    name: 'Home'
                },
                {
                    value: 'verb',
                    name: 'Annotation'
                },
                {
                    value: 'newcircle',
                    name: 'Map'
                },
                {
                    value: 'Visulization',
                    name: 'Visulization',
                    href:'https://navigation.acemap.info/#/'
                },
                {
                    value: 'login',
                    name: 'Sign In'
                },
            ],
            
        }
    },
    methods:{
        logout(){
            this.$store.commit('changeusername','')
            localStorage.removeItem("username");
            localStorage.removeItem("userid");
            localStorage.removeItem("token");
            this.$router.push('/login')
        },
    },
    mounted() {
       
    },
}
</script>
<style lang="less" scoped>
    .header {
       

        .layout-right {
            display: flex;
            align-items: center;
        }
        .title {
            font-family: Source Han Sans SC;
            font-weight: 900;
            font-size: 28px;
            margin-left: 16px;
            vertical-align: bottom;
        }
        .link {
            margin-left: 36px;
            cursor: pointer;
        }
        .highlight {
            font-weight: 900;
        }
        .hidden-logo {
            visibility: hidden;
        }
        .link a, .router-link-active {
            color: inherit;
            text-decoration: none;
        }

    }
    .dark-style {
        color: #000;
        background: transparent;
    }
    .fb-newrightlogo{
        width: 80px;
    }
    .logout{
        display: none;
        position: absolute;
        top: 40px;
        left: 0;
        border: 1px solid orange;
        background-color: orange;
        color: white;
        padding: 10px;
        border-radius: 5px;
        line-height: 1;
    }
    .login-wrap{
        position: relative;
        min-width: 100px;
        height: 50px;
        line-height: 50px;
        display: inline-block;
    }
    .login-wrap:hover{
        .logout{
            display: inline-block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue